/** Format YYYY-MM-DD → DD/MM/YYYY */
export function fmtDate(d) {
  if (!d) return "";
  const p = d.split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : d;
}

/** Format ISO timestamp → DD/MM/YYYY HH:mm */
export function fmtDateTime(ts) {
  if (!ts) return "";
  try {
    const d = new Date(ts);
    const day = String(d.getDate()).padStart(2, "0");
    const mon = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const h = String(d.getHours()).padStart(2, "0");
    const m = String(d.getMinutes()).padStart(2, "0");
    return `${day}/${mon}/${year} ${h}:${m}`;
  } catch { return ts; }
}

/** Format ISO timestamp → HH:mm only */
export function fmtTime(ts) {
  if (!ts) return "";
  try {
    const d = new Date(ts);
    return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  } catch { return ts; }
}
